<template>
  <div class="header">
    <div class="menu">
      <i
        aria-hidden="true"
        class="v-icon notranslate mdi mdi-menu theme--dark"
        @click.stop="toggleMenu"
      ></i>
    </div>
    <div class="banner"></div>
    <a href="/contact">
      <div class="help"></div>
    </a>
    <div class="obstacle"></div>
    <router-link :to="{
      name: 'notificationsall',
      }">
      <div class="bell">
        <v-badge color="#d5132f">
          <template v-if="profile.notifications > 0" v-slot:badge>
            <span>{{ profile.notifications }}</span>
          </template>
          <font-awesome-icon class="alert-bell" icon="bell" />
        </v-badge>
      </div>
    </router-link>
    <div class="userinfo" ref="prev" v-bind:class="{ active: toggleopen }">
      <router-link to="/idmsettings">
        <v-avatar size="29px" class="useravatar">
          <img src="/assets/images/user.jpg" />
        </v-avatar>
      </router-link>
      <li
        class="user"
        @click="toggle()"
        :class="{ open: toggleopen }"
        v-click-outside="hideMenu"
      >
        <a class="menu__link--toggle">
          <span class="username">{{ profile.username }}</span>
          <font-awesome-icon class="down-arrow" icon="chevron-down" />
        </a>
        <ul class="dropdown-menu" :style="dropmenuwidth">
          <li class="dropdown-menu__item" @click="logout">
            <a class="dropdown-menu__link" href="#">
              <font-awesome-icon class="log-out" icon="power-off" />
              <span>Log out</span>
            </a>
          </li>
        </ul>
      </li>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import vClickOutside from 'v-click-outside';
Vue.use(vClickOutside);

export default {
  ready() {
    var self = this;
    window.addEventListener(
      "click",
      function(e) {
        if (!e.target.parentNode.classList.contains("menu__link--toggle")) {
          self.close();
        }
      },
      false
    );
  },
  data() {
    return {
      dropdownwidth: 0,
      toggleopen: false,
      username: "",
      notficationcount: 0
    };
  },
  mounted() {
    this.$store.dispatch("aboutMe");
  },
  computed: {
    dropmenuwidth() {
      return `width: ${this.dropdownwidth}px;`;
    },
    profile() {
      return this.$store.state.user.profile;
    }
  },
  methods: {
    logout() {
      this.$store
        .dispatch("logout", {})
        .then(() => {
          this.$router.push({ path: "/login" });
        })
        .catch(() => {});
    },
    getDropdownWidth() {
      this.dropdownwidth = this.$refs.prev.clientWidth;
    },
    toggle(dropdownName) {
      this.getDropdownWidth();
      this.toggleopen = !this.toggleopen;
    },
    hideMenu(dropdownName) {
      this.toggleopen = false;
    }
  }
};
</script>
